import { post, get, exportPost } from "../services/http";
import environment from '../environment';
const {
    URL_SERVICE_ACCOUNT_MAIN,
    URL_SERVICE,
    URL_SERVICE_MAINSERVICE
} = environment;

export default {
    //#region 导出
    //获取账户下记录
    ZD_RecordFetch({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/exportservice/record/fetch', params);
    },
    //删除账户下记录
    ZD_RecordDelete({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/exportservice/record/delete', params);
    },
    //收款明细--时间范围
    EXPORT_ReceiveRangeTime({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/exportservice/mainservice/land/pc/home/receive/rangeTime', params);
    },
    //使用明细--时间范围
    EXPORT_UseKwhRangeTime({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/exportservice/mainservice/land/pc/home/use/kwh/rangeTime', params);
    },
    //历史数据--时间范围
    EXPORT_HistoryListData({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/exportservice/mainservice/land/pc/home/room/device/list/history', params);
    },
    //#endregion

    //账号登录
    ZD_DoLoginUser({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/doLogin/user/pc', params);
    },
    //手机号登录
    ZD_DoLoginPhone({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/doLogin/phone/pc', params);
    },
    //首次登录修改密码并将此次登录置为有效
    ZD_DoLoginPasswordUpdate({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/doLogin/password/update', params);
    },
    //APS平台登录 登录信息从总片区获取，此处仅片区1登记登录信息
    ZD_LoginInV1({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/accountservice/login/loginIn/v1', params);
    },
    //收款明细--时间范围
    ZD_ReceiveRangeTime({ dispatch, commit, state }, params) {
        return get(URL_SERVICE + '/mainservice/land/pc/home/receive/rangeTime', params);
    },
    //收款明细--统计数据
    ZD_ReceiveTatistics({ dispatch, commit, state }, params) {
        return get(URL_SERVICE + '/mainservice/land/pc/home/receive/tatistics', params);
    },
    //使用明细--时间范围
    ZD_UseKwhRangeTime({ dispatch, commit, state }, params) {
        return get(URL_SERVICE + '/mainservice/land/pc/home/use/kwh/rangeTime', params);
    },
    //房东层级列表
    ZD_RootSimpleList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE + '/mainservice/land/root/simple/list', params);
    },
    // 层级列表
    ZD_SimpleLevelList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/root/simple/list', params)
    },
    // 添加层级
    ZD_SimpleLevelAdd({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/root/add', params)
    },
    // 修改层级
    ZD_SimpleLevelUpdate({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/root/update', params)
    },
    // 删除层级
    ZD_SimpleLevelDelete({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/root/delete', params)
    },
    // 房东设备列表
    ZD_LandlordEquipmentList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/pc/root/device/list', params)
    },
    // 房东添加设备
    ZD_LandlordEquipmentAdd({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/add', params)
    },
    // 删除设备
    ZD_LandlordEquipmentDelete({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/delete', params)
    },
    // 价格列表
    ZD_ElectricityPricesList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/price/list', params)
    },
    // 添加电价方案
    ZD_ElectricityPricesAdd({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/price/add', params)
    },
    // 删除电价方案
    ZD_ElectricityPricesDelete({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/price/delete', params)
    },
    // 编辑电价方案
    ZD_ElectricityPricesUpdate({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/price/update', params)
    },
    // 更换租客
    ZD_ChangeTenants({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/change/tenant', params)
    },
    // 获取的单个层级下设备与价格
    ZD_HierarchicalPrice({ dispatch, commits, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/root/device/price/list', params)
    },
    // 单个层级下批量修改设备价格
    ZD_BatchModificationOfPrices({ diapatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/root/batch/price/update', params)
    },
    // 单个层级下水表批量修改设备价格
    ZD_WaterBatchModificationOfPrices({ diapatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/root/batch/price/update/water', params)
    },
    // 代客充值token形式
    ZD_ValetRecharge({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/recharge', params)
    },
    // 电表详情
    ZD_MeterDeviceDetails({ dispatch, sommit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/detail', params)
    },
    // 修改电表名称
    ZD_ChangeDeviceName({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/modify/name', params)
    },
    // 充值记录
    ZD_RechargeRecord({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/device/recharge/log', params)
    },
    // 操作记录
    ZD_OperationRecord({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/device/msg/list', params)
    },
    // 费用明细
    ZD_ExpenseDetails({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/device/use/kwh/dayly', params)
    },
    // 设备-通电
    ZD_DeviceIsPoweredOn({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/power/on', params)
    },
    // 设备-断电
    ZD_DeviceIsPoweredOff({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/power/off', params)
    },
    // 操作阀关 token形式
    ZD_WaterOptValveClose({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/opt/valve/close', params)
    },
    // 操作阀开 token形式
    ZD_WaterOptValveOpen({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/opt/valve/open', params)
    },
    // 设备-刷新
    ZD_DeviceRefresh({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/callInstant', params)
    },
    // 设备-清窃电
    ZD_EliminateElectricityTheft({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/clear/steal', params)
    },
    // 设备-清零
    ZD_DeviceClearing({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/clear/energy', params)
    },
    // 设备-修改价格
    ZD_EquipmentEditPrice({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/change/price', params)
    },
    // 修改昵称
    ZD_UserChangeNickname({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/account/nickname/update', params)
    },
    // 修改密码
    ZD_UserChangeThePassword({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/account/password/update', params)
    },
    // 设备消息-第一条消息
    ZD_DeviceMessageOne({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/home/msg/index', params)
    },
    // 账号消息-第一条消息
    ZD_AccountMessageOne({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_ACCOUNT_MAIN + '/account/msg/index', params)
    },
    // 设备消息列表
    ZD_DeviceMessageList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/home/msg/list', params)
    },
    // 账号消息列表
    ZD_AccountMessageList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_ACCOUNT_MAIN + '/account/msg/list', params)
    },
    // 公告消息-第一条消息
    ZD_AdvertisementMessage({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_ACCOUNT_MAIN + '/notice/last', params)
    },
    // 公告消息列表
    ZD_AnnouncementMessageList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_ACCOUNT_MAIN + '/notice/list', params)
    },
    // 国家配置列表
    ZD_CountryConfigurationList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_ACCOUNT_MAIN + '/get/common/nation/list', params)
    },
    // 业主设置国家配置
    ZD_NationalSettings({ dispatch, commit, state }, params) {
        return post(URL_SERVICE + '/accountservice/Land/setNation', params)
    },
    // 读取功率门限
    ZD_ReadPowerLimit({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/param/read/power-limit', params)
    },
    // 设置功率门限
    ZD_WritePowerLimit({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/opt/param/write/power-limit', params)
    },
    // 设备列表 -- 历史数据
    ZD_DeviceListHistoryData({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/pc/home/room/device/list/history', params)
    },
    // 据表号查询表类型
    ZD_DeviceBrowserMeterType({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/device/Browser/MeterType', params)
    },
    // 水价列表
    ZD_WaterPricesList({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/price/list/water', params)
    },
    // 获取单个层级下的水表设备与价格
    ZD_HierarchicalWaterPrice({ dispatch, commits, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/root/device/water/price/list', params)
    },
    // 首页-添加水表
    ZD_DeviceWaterAdd({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/add', params)
    },
    // 代客充值token形式
    ZD_ValetWaterRecharge({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/recharge', params)
    },
    // 水表详情
    ZD_MeterDeviceWaterDetails({ dispatch, sommit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/detail', params)
    },
    // 水表设备-修改价格
    ZD_EquipmentWaterEditPrice({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/change/price', params)
    },
    // 水表-费用明细
    ZD_WaterExpenseDetails({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/device/water/use/water/dayly', params)
    },
    // 水表-充值记录
    ZD_WaterRechargeRecord({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/device/water/recharge/log', params)
    },
    // 水表-删除设备
    ZD_LandlordWaterEquipmentDelete({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/delete', params)
    },
    // 水表清电量 token形式
    ZD_WaterOptClearEnergy({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_MAINSERVICE + '/land/device/water/opt/clear/energy', params)
    },
    // 层级设备列表v2无筛选功能
    ZD_RootDeviceListV2({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_MAINSERVICE + '/land/pc/root/device/list/v2', params)
    },
    //#region 二级密码
    // 获取2级密码是否已启用 0未启用、1密码、2短信验证码
    ZD_SecurityPasswordInfo({ dispatch, commit, state }, params) {
        return get(URL_SERVICE_ACCOUNT_MAIN + '/land/security/password/info', params)
    },
    // 设置或修改2级密码
    ZD_SecurityPasswordUpdate({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/land/security/password/update', params)
    },
    // 删除2级密码
    ZD_SecurityPasswordDel({ dispatch, commit, state }, params) {
        return post(URL_SERVICE_ACCOUNT_MAIN + '/land/security/password/del', params)
    },
    //#endregion
}
